// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 744px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/popovers/set-rls-for-test-report-popover/set-rls-for-test-report-popover.component.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ","sourcesContent":["ion-content {\n    height: 744px !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
